/* eslint-disable react/display-name */
/**
 *
 * FormularioPreguntas
 *
 */

import { memo } from 'react';

import { lazyLoad } from 'utils/loadable';

import { ParametersRouting } from './parameters.routing';
interface Props {}

export const ParametersComponent = memo((props: Props) => {
  return (
    <>
      <div></div>
      <ParametersRouting />
    </>
  );
});

export const ParametersModule = lazyLoad(
  () => import('./parameters.module'),
  (module) => module.ParametersComponent
);
